class Module04Steps {
	constructor() {
		let cache = {};
		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.stepsModules = document.querySelectorAll(".module-04-steps");
		};

		let registerEvents = () => {
			initSmoothScroll();

			cache.stepsModules.forEach((module) => {
				const numbers = module.querySelectorAll(".step-number");
				const contents = module.querySelectorAll(".step-content");
				let observer;

				const options = {
					root: null,
					rootMargin: "-50% 0px -50% 0px",
					threshold: [0, 0.15, 0.3, 0.45, 0.6],
				};

				observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const index = parseInt(entry.target.dataset.index);

							entry.target.classList.add("active");
							
							// Active le numéro correspondant
							numbers.forEach((num, i) => {
								num.classList.toggle("active", i === index);
							});
						}
					});
				}, options);

				contents.forEach((content) => {
					observer.observe(content);
				});

				if (numbers[0]) numbers[0].classList.add("active");
			});
		};

        let initSmoothScroll = () => {
			cache.stepsModules.forEach((module) => {
				const links = module.querySelectorAll('.step-number');
				
				links.forEach(link => {
					link.addEventListener('click', (e) => {
						e.preventDefault();
						const targetId = link.getAttribute('href');
						const targetElement = document.querySelector(targetId);
						
						if (targetElement) {
							const offset = 100; // Pixel en fonction du header
							const elementPosition = targetElement.getBoundingClientRect().top;
							const offsetPosition = elementPosition + window.pageYOffset - offset;

							window.scrollTo({
								top: offsetPosition,
								behavior: 'smooth'
							});
						}
					});
				});
			});
		};

		initFunc();
	}
}

export { Module04Steps };
